// src/push-utils.js
export function urlBase64ToUint8Array(base64String) {
    // helper برای تبدیل public VAPID key
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

export async function registerServiceWorkerAndSubscribe(vapidPublicKey) {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        throw new Error('Push or Service Worker not supported.');
    }

    // ثبت Service Worker
    const registration = await navigator.serviceWorker.register('/sw.js');
    await navigator.serviceWorker.ready;

    // گرفتن مجوز نوتیف
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
        throw new Error('Notification permission not granted');
    }

    // گرفتن subscription
    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
    });

    return subscription.toJSON(); // JSON قابل ارسال به سرور
}
